import React, { useContext } from 'react';
import { DataContext } from '../providers/dataProvider';
import { PopUpContext } from '../providers/popUpProvider';
import lc from "../cmprtbl.module.scss";

function Popup() {
    const ctx = useContext( DataContext );
    const { data: { gui: { popUpLinkText } } } = ctx;
    const popUpCtx = useContext( PopUpContext );
    const { popUp, setPopUp } = popUpCtx;

    return (
        popUp && (
            <div className={ `${ lc.popup } ${ popUp ? lc.show : '' }` }>
                <div className={ lc.container }>
                    <button type="button" onClick={ () => setPopUp( null ) } className={ lc.close_button }></button>
                    <h2>{ popUp.name }</h2>
                    <p>{ popUp.popup.text }</p>
                    <figure>
                        { popUp.popup.image && ( typeof popUp.popup.image === 'string' ) && (
                            <img alt="" src={ `${popUp.popup.image}` } />
                        ) }
                        { popUp.popup.image && ( typeof popUp.popup.image === 'object' ) && popUp.popup.image.map( ( image ) => ( <img alt="" src={ `${image}` } /> ) ) }
                    </figure>
                    { popUp.popup.link && <a href={ popUp.popup.link } target="_self">{ popUpLinkText }</a> }
                </div>
            </div>
        )
    );
}

export default Popup;
